// extracted by mini-css-extract-plugin
module.exports = {"ReactQuill":"Editor_ReactQuill__sJB6F"};